// extracted by mini-css-extract-plugin
module.exports = {"mobileMenuTrigger":"MobileMenuTrigger_mobile-menu-trigger__THcDL","fadeIn":"MobileMenuTrigger_fadeIn__8bp6e","active":"MobileMenuTrigger_active__JiZvl"};